var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.52459 3.71209C6.15847 4.0782 6.15847 4.6718 6.52459 5.03791L11.4867 10L6.52459 14.9621C6.15847 15.3282 6.15847 15.9218 6.52459 16.2879C6.8907 16.654 7.4843 16.654 7.85041 16.2879L13.4754 10.6629C13.8415 10.2968 13.8415 9.7032 13.4754 9.33709L7.85041 3.71209C7.4843 3.34597 6.8907 3.34597 6.52459 3.71209Z",
    fill: "#8493B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontIcon);
export default __webpack_public_path__ + "static/media/frontIcon.302024be87626eaa47148717d866ca50.svg";
export { ForwardRef as ReactComponent };